import { render, staticRenderFns } from "./Notifier.vue?vue&type=template&id=4c7a5ad8&scoped=true&"
import script from "./Notifier.vue?vue&type=script&lang=ts&"
export * from "./Notifier.vue?vue&type=script&lang=ts&"
import style0 from "./Notifier.vue?vue&type=style&index=0&id=4c7a5ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7a5ad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VScrollYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAlert,VScrollYReverseTransition})
